import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-schedule-page" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "month-selector" }
const _hoisted_4 = { class: "year" }
const _hoisted_5 = { class: "month" }
const _hoisted_6 = { class: "calendar-card" }
const _hoisted_7 = { class: "calendar-header" }
const _hoisted_8 = { class: "calendar-body" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "day-number" }
const _hoisted_11 = {
  key: 0,
  class: "work-indicator"
}
const _hoisted_12 = {
  key: 0,
  class: "work-count"
}
const _hoisted_13 = { class: "summary-card" }
const _hoisted_14 = {
  key: 0,
  class: "loading-summary"
}
const _hoisted_15 = {
  key: 1,
  class: "summary-grid"
}
const _hoisted_16 = { class: "summary-item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "summary-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "summary-item" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 0,
  class: "schedule-list-section"
}
const _hoisted_23 = { class: "section-title" }
const _hoisted_24 = { class: "schedule-list" }
const _hoisted_25 = { class: "day-header" }
const _hoisted_26 = { class: "day-date" }
const _hoisted_27 = { class: "day-label" }
const _hoisted_28 = { class: "day-count" }
const _hoisted_29 = { class: "services-list" }
const _hoisted_30 = { class: "service-time" }
const _hoisted_31 = { class: "service-info" }
const _hoisted_32 = { class: "patient-name" }
const _hoisted_33 = { class: "suga-name" }
const _hoisted_34 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_35 = { class: "dialog-header" }
const _hoisted_36 = {
  key: 0,
  class: "dialog-content"
}
const _hoisted_37 = { class: "service-header" }
const _hoisted_38 = { class: "time" }
const _hoisted_39 = { class: "duration" }
const _hoisted_40 = { class: "service-body" }
const _hoisted_41 = { class: "info-row" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 0,
  class: "info-row"
}
const _hoisted_44 = { class: "value" }
const _hoisted_45 = {
  key: 1,
  class: "dialog-content empty"
}

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpSchedule',
  setup(__props) {

const store = useStore();

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);
const empName = computed(() => pwaUser.value?.emp_name || '');
const empBirth = computed(() => pwaUser.value?.emp_birth || '');
const sisulCode = computed(() => pwaUser.value?.m_sisul_code || '');

// 현재 날짜
const today = new Date();
const selectedYear = ref(today.getFullYear());
const selectedMonth = ref(today.getMonth() + 1);

// 데이터
const isLoading = ref(false);
const scheduleData = ref<any[]>([]);
const workSummary = ref({
  workDays: 0,
  serviceCount: 0,
  totalMinutes: 0
});

// 다이얼로그
const showDetailDialog = ref(false);
const selectedDay = ref<any>(null);

// 요일 이름
const weekDays = ['일', '월', '화', '수', '목', '금', '토'];

// 월 변경
const changeMonth = (delta: number) => {
  let newMonth = selectedMonth.value + delta;
  let newYear = selectedYear.value;
  
  if (newMonth > 12) {
    newMonth = 1;
    newYear++;
  } else if (newMonth < 1) {
    newMonth = 12;
    newYear--;
  }
  
  selectedMonth.value = newMonth;
  selectedYear.value = newYear;
};

// 현재 월로 이동
const goToCurrentMonth = () => {
  selectedYear.value = today.getFullYear();
  selectedMonth.value = today.getMonth() + 1;
};

// 년월 문자열 생성
const yearMonth = computed(() => {
  return `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;
});

// 근무 일자 집합 (빠른 조회용)
const workDatesSet = computed(() => {
  const dates = new Set<string>();
  scheduleData.value.forEach(item => {
    if (item.leb_date) {
      dates.add(item.leb_date);
    }
  });
  return dates;
});

// 일자별 근무 횟수
const workCountByDate = computed(() => {
  const counts: Record<string, number> = {};
  scheduleData.value.forEach(item => {
    if (item.leb_date) {
      counts[item.leb_date] = (counts[item.leb_date] || 0) + 1;
    }
  });
  return counts;
});

// 일자별 서비스 목록
const servicesByDate = computed(() => {
  const map: Record<string, any[]> = {};
  scheduleData.value.forEach(item => {
    if (item.leb_date) {
      if (!map[item.leb_date]) {
        map[item.leb_date] = [];
      }
      map[item.leb_date].push(item);
    }
  });
  return map;
});

// 그룹화된 스케줄 (일자별)
const groupedSchedule = computed(() => {
  const dates = Object.keys(servicesByDate.value).sort();
  return dates.map(date => ({
    date,
    services: servicesByDate.value[date]
  }));
});

// 캘린더 일수 계산
const calendarDays = computed(() => {
  const year = selectedYear.value;
  const month = selectedMonth.value;
  
  // 해당 월의 첫 날과 마지막 날
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);
  
  // 첫 주의 시작 (일요일부터)
  const startDay = new Date(firstDay);
  startDay.setDate(startDay.getDate() - firstDay.getDay());
  
  const days = [];
  const current = new Date(startDay);
  
  // 6주 표시 (42일)
  for (let i = 0; i < 42; i++) {
    const isCurrentMonth = current.getMonth() === month - 1;
    const isToday = 
      current.getFullYear() === today.getFullYear() &&
      current.getMonth() === today.getMonth() &&
      current.getDate() === today.getDate();
    const isWeekend = current.getDay() === 0 || current.getDay() === 6;
    
    // 날짜 문자열 생성 (YYYY-MM-DD)
    const dateStr = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}-${String(current.getDate()).padStart(2, '0')}`;
    const hasWork = isCurrentMonth && workDatesSet.value.has(dateStr);
    const workCount = workCountByDate.value[dateStr] || 0;
    
    days.push({
      day: current.getDate(),
      fullDate: dateStr,
      isCurrentMonth,
      isToday,
      isWeekend,
      hasWork,
      workCount,
      services: servicesByDate.value[dateStr] || []
    });
    
    current.setDate(current.getDate() + 1);
  }
  
  return days;
});

// 시간 포맷 (HHMM -> HH:mm)
const formatTimeToDisplay = (time: string): string => {
  if (!time) return '';
  const str = time.toString().replace(/[^0-9]/g, '');
  if (str.length >= 4) {
    return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
  }
  return time;
};

// 날짜 포맷 (YYYYMMDD -> YYYY-MM-DD)
const formatDateToStandard = (date: string): string => {
  if (!date) return '';
  // 이미 YYYY-MM-DD 형식이면 그대로 반환
  if (date.includes('-')) return date;
  const str = date.toString().replace(/[^0-9]/g, '');
  if (str.length === 8) {
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
  }
  return date;
};

// 데이터 조회 (일정계획 테이블 사용 - les_)
const fetchScheduleData = async () => {
  if (!empName.value || !sisulCode.value) {
    console.warn('사원 정보가 없습니다.');
    return;
  }

  isLoading.value = true;
  try {
    const encodedName = encodeURIComponent(empName.value);
    const birth = empBirth.value || 'null';
    
    // 일정계획과 요약 동시 조회 (schedule-plan API 사용)
    const [scheduleRes, summaryRes] = await Promise.all([
      axios.get(`/api/emp/schedule-plan/${encodedName}/${birth}/${sisulCode.value}/${yearMonth.value}`, {
        withCredentials: true
      }),
      axios.get(`/api/emp/schedule-plan-summary/${encodedName}/${birth}/${sisulCode.value}/${yearMonth.value}`, {
        withCredentials: true
      })
    ]);

    if (scheduleRes.data.success) {
      // les_ 필드를 leb_ 필드 형식으로 변환하여 기존 템플릿 호환성 유지
      scheduleData.value = (scheduleRes.data.data || []).map((item: any) => ({
        leb_date: formatDateToStandard(item.les_date),
        leb_start_time: formatTimeToDisplay(item.les_start_time),
        leb_end_time: formatTimeToDisplay(item.les_end_time),
        leb_patient_name: item.les_patient_name,
        leb_suga_name: item.les_suga_name,
        leb_service_gubun: item.les_service_gubun
      }));
    } else {
      scheduleData.value = [];
    }

    if (summaryRes.data.success) {
      const data = summaryRes.data.data;
      workSummary.value = {
        workDays: data.work_days || 0,
        serviceCount: data.service_count || 0,
        totalMinutes: data.total_minutes || 0
      };
    } else {
      workSummary.value = { workDays: 0, serviceCount: 0, totalMinutes: 0 };
    }
  } catch (error) {
    console.error('일정계획 조회 오류:', error);
    scheduleData.value = [];
    workSummary.value = { workDays: 0, serviceCount: 0, totalMinutes: 0 };
  } finally {
    isLoading.value = false;
  }
};

// 시간 포맷 (분 -> 시간)
const formatHours = (minutes: number): string => {
  if (!minutes) return '0h';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};

// 날짜 포맷 (짧은 형식)
const formatDateShort = (dateStr: string): string => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parseInt(parts[1])}/${parseInt(parts[2])}`;
  }
  return dateStr;
};

// 날짜 포맷 (전체)
const formatDateFull = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('ko-KR', {
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
  } catch {
    return dateStr;
  }
};

// 요일 구하기
const getDayOfWeek = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return weekDays[d.getDay()];
  } catch {
    return '';
  }
};

// 시간 차이 계산
const calculateDuration = (start: string, end: string): string => {
  if (!start || !end) return '';
  try {
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    const startMinutes = sh * 60 + sm;
    const endMinutes = eh * 60 + em;
    const diff = endMinutes - startMinutes;
    if (diff <= 0) return '';
    const hours = Math.floor(diff / 60);
    const mins = diff % 60;
    if (hours === 0) return `${mins}분`;
    if (mins === 0) return `${hours}시간`;
    return `${hours}시간 ${mins}분`;
  } catch {
    return '';
  }
};

// 일자 상세 보기
const showDayDetail = (day: any) => {
  if (!day.isCurrentMonth) return;
  selectedDay.value = day;
  showDetailDialog.value = true;
};

// 월 변경 시 데이터 재조회
watch([selectedYear, selectedMonth], () => {
  fetchScheduleData();
});

onMounted(() => {
  fetchScheduleData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "app-header" }, [
      _createElementVNode("div", { class: "header-title" }, "일정계획")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "nav-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMonth(-1)))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "current-month",
          onClick: goToCurrentMonth
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(selectedYear.value) + "년", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(selectedMonth.value) + "월", 1)
        ]),
        _createElementVNode("button", {
          class: "nav-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMonth(1)))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
            return _createElementVNode("span", {
              key: day,
              class: "day-name"
            }, _toDisplayString(day), 1)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["calendar-day", {
            'other-month': !day.isCurrentMonth,
            'today': day.isToday,
            'has-work': day.hasWork,
            'weekend': day.isWeekend
          }]),
              onClick: ($event: any) => (showDayDetail(day))
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(day.day), 1),
              (day.hasWork)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (day.workCount > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(day.workCount), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_9))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h3", null, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#059669"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-chart-bar", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(selectedMonth.value) + "월 근무 요약 ", 1)
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: "24",
                color: "#059669"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(workSummary.value.workDays), 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "근무일", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(formatHours(workSummary.value.totalMinutes)), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "총 시간", -1))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(workSummary.value.serviceCount), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "서비스 건", -1))
              ])
            ]))
      ]),
      (scheduleData.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("h3", _hoisted_23, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#059669"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-calendar-text", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(selectedMonth.value) + "월 근무 상세 ", 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSchedule.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "schedule-day-group"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(formatDateShort(item.date)), 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(getDayOfWeek(item.date)), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.services.length) + "건", 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.services, (service, sIdx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sIdx,
                        class: "service-item"
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "#9ca3af"
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-clock-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", null, _toDisplayString(service.leb_start_time) + " ~ " + _toDisplayString(service.leb_end_time), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(service.leb_patient_name), 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(service.leb_suga_name || service.leb_service_gubun), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#d1d5db"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-calendar-blank", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(selectedMonth.value) + "월 근무 내역이 없습니다.", 1)
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showDetailDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDetailDialog).value = $event)),
        "max-width": "360"
      }, {
        default: _withCtx(() => [
          (selectedDay.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "detail-dialog-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("h2", null, _toDisplayString(formatDateFull(selectedDay.value.fullDate)), 1),
                    _createElementVNode("button", {
                      class: "close-btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetailDialog.value = false))
                    }, [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  (selectedDay.value.services && selectedDay.value.services.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDay.value.services, (service, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "detail-service-item"
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("span", _hoisted_38, _toDisplayString(service.leb_start_time) + " ~ " + _toDisplayString(service.leb_end_time), 1),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(calculateDuration(service.leb_start_time, service.leb_end_time)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "수급자", -1)),
                                _createElementVNode("span", _hoisted_42, _toDisplayString(service.leb_patient_name), 1)
                              ]),
                              (service.leb_suga_name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "서비스", -1)),
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(service.leb_suga_name), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createVNode(_component_v_icon, {
                          size: "40",
                          color: "#d1d5db"
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-calendar-blank", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createElementVNode("p", null, "이 날에는 근무 내역이 없습니다.", -1))
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})